<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
        <div class="col-md-12 mainheader header-container">
            <h5>Orders Entry - New Mode</h5>
        </div>
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
        <!-- card -->
        <div class="card">
            <!-- card body -->
            <div class="card-body">
                <!-- top row -->
                <div class="row">
                    <!-- col -->
                    <div class="col-md-6">
                        <div class="border p-3 h-100">
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Order Number</label>
                                        <input type="text" class="form-control" placeholder="Order Number">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Order Series</label>
                                        <input type="text" class="form-control" placeholder="Order Number">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!--col -->
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Booking Date</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="zmdi zmdi-calendar"></i></span>
                                            </div>
                                            <input type="text" class="form-control datepicker"
                                                placeholder="Booking Date">
                                        </div>
                                    </div>
                                </div>
                                <!--/col -->
                                <!--col -->
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Trail Date</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="zmdi zmdi-calendar"></i></span>
                                            </div>
                                            <input type="text" class="form-control datepicker" placeholder="Trail Date">
                                        </div>
                                    </div>
                                </div>
                                <!--/col -->
                                <!--col -->
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Delivery Date</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="zmdi zmdi-calendar"></i></span>
                                            </div>
                                            <input type="text" class="form-control datepicker"
                                                placeholder="Delivery Date">
                                        </div>
                                    </div>
                                </div>
                                <!--/col -->
                                <!-- col -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Notes</label>
                                        <textarea class="form-control"></textarea>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                        </div>
                    </div>
                    <!--/ col -->
                    <!-- right col -->
                    <div class="col-md-6">
                        <div class="border p-3 h-100">
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Account Code</label>
                                        <input type="text" class="form-control" placeholder="Account Code">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Account Name</label>
                                        <input type="text" class="form-control" placeholder="Account Name">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Account Name, Address-1, Address-2, Town, Phone, Mobile, Email</label>
                                        <textarea class="form-control" style="height:100px;"></textarea>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                <button class="btn redbtn" [routerLink]="['/order-images']" type="button">Add
                                    Images</button>
                                <button class="btn redbtn" type="button">Cancel</button>
                                <button class="btn redbtn" type="button">Create</button>
                            </div>
                        </div>
                    </div>
                    <!--/right  col -->
                </div>
                <!--/ top row -->
                <!-- buttons row -->
                <div class="p-3 border h-100 my-3">
                    <div class="row py-3">
                        <div class="col-md-12">
                            <h4 class="text-center mb-3">Select Items</h4>
                            <div class="dressItems row justify-content-center">
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress01.jpg" alt="">
                                        <span>Shirts</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress02.jpg" alt="">
                                        <span>Trousers</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress03.jpg" alt="">
                                        <span>Sarvani</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress04.jpg" alt="">
                                        <span>Lalchi</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress05.jpg" alt="">
                                        <span>Fizama</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress06.jpg" alt="">
                                        <span>Half Hand Shirt</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress07.jpg" alt="">
                                        <span>Full Hand Shirt</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress08.jpg" alt="">
                                        <span>Uniform Trousers</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress09.jpg" alt="">
                                        <span>Safari Curta</span>
                                    </a>
                                </div>
                                <div class="col-6 col-sm-4 col-md-2 text-center ">
                                    <a href="javascript:void(0)">
                                        <img src="assets/images/dresses/dress10.jpg" alt="">
                                        <span>Safari Trousers</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--/ buttons row -->
                <!-- right table -->
                <!-- <div class="border p-3 h-100" >
                   
                    <h4>Shirt Size &amp; Value</h4>
                    <div class="row" *ngIf="isShown" >
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Length</label>
                                <input type="text" class="form-control" placeholder="Length">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Chest</label>
                                <input type="text" class="form-control" placeholder="Chest">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Body</label>
                                <input type="text" class="form-control" placeholder="Body">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Hip</label>
                                <input type="text" class="form-control" placeholder="Hip">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Shoulder</label>
                                <input type="text" class="form-control" placeholder="Shoulder">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Calour</label>
                                <input type="text" class="form-control" placeholder="Calour">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Full hand</label>
                                <input type="text" class="form-control" placeholder="Full hand">
                            </div>
                        </div> -->
                <!-- <div class="col-md-3">
                            <div class="form-group">
                                <label>Half hand</label>
                                <input type="text" class="form-control" placeholder="Half hand">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Model</label>
                                <input type="text" class="form-control" placeholder="Half hand"
                                    value="11/4B 8LSP 1HP">
                            </div>
                        </div>
                        <div class="col-md-3">
                            
                                <button class=" btn redbtn float-right" (click)="sizeShow()" type="button">Save Item</button>
                            
                        </div>
                        
                    </div> -->
                <!--/ new item row-->
                <div class="table-responsive">
                    <table class="table table-bordered table-striped table-hover js-basic-example dataTable kliqtable">
                        <thead>
                            <tr>
                                <th>QTY</th>
                                <th>Item Name</th>
                                <th>Rate</th>
                                <th>Amount</th>
                                <th>Add size</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1 </td>
                                <td>Shirts </td>
                                <td> 250.00 </td>
                                <td> 250.00 </td>
                                <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem"><i class="fa fa-tshirt"></i> Size</button>
                                </td>
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem"><i class="fas fa-tshirt"></i> Size</button>
                                </td>
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem">Size</button>
                                </td>
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem">Size</button>
                                </td>
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem">Size</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!--/ right table -->
            <!-- final row -->
            <div class="row">
                <div class="col-md-3">
                    <div class="p-3 border h-100 mt-3 h-100">
                        <div class="form-group">
                            <label>SMS Message</label>
                            <textarea class="form-control"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="p-3 border mt-3 h-100">
                        <div class="row">
                            <div class="col-md-2 col-sm-4">
                                <h6>Total Items </h6>
                                <p><b>1</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>Total Qty </h6>
                                <p><b>1</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>Total Amt </h6>
                                <p><b>250.00</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>Adv Amt </h6>
                                <p><b>100.00</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6> Bill Amount </h6>
                                <p><b>250.00</b></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--/final row -->
        </div>
        <div class="modal fade" id="createNewItem" tabindex="-1" role="dialog">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="title" id="largeModalLabel">Shirt Size &amp; Value</h4>
                    </div>
                    <div class="modal-body border h-30">
                        <form>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Length<input type="text" class="form-control"
                                                placeholder="Length"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Chest <input type="text" class="form-control"
                                                placeholder="Chest"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Body <input type="text" class="form-control" placeholder="Body"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Hip <input type="text" class="form-control" placeholder="Hip"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Shoulder <input type="text" class="form-control"
                                                placeholder="Shoulder"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Calour <input type="text" class="form-control"
                                                placeholder="Calour"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Full hand <input type="text" class="form-control"
                                                placeholder="Full hand"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Half hand <input type="text" class="form-control"
                                                placeholder="Half hand"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Model <input type="text" class="form-control" placeholder="Half hand"
                                                value="11/4B 8LSP 1HP"></label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default btn-round waves-effect">SAVE CHANGES</button>
                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">CLOSE</button>
                    </div>
                </div>
            </div>
        </div>
        <!--/ card body -->
        <div class="card-footer text-left w-100">
            <button class="btn redbtn" type="button">Customer</button>
            <button class="btn redbtn" type="button">Settlement</button>
            <button class="btn redbtn" type="button">Save</button>
            <button class="btn redbtn" type="button">Save & Print</button>
            <button class="btn redbtn" type="button">Refresh</button>
            <button class="btn redbtn" type="button">Close</button>
            <button class="btn redbtn" type="button">Save</button>
        </div>
        <!-- </div> -->
        <!--/ card -->
    </main>
    <!-- main body -->
</div>